import React from 'react';
import { TileInfo } from 'app/home/index.functions';
import { ReportingToolIcon } from './ReportingToolIcon';
import useBundleTranslation from 'i18n';
import { UserAuth } from 'store/auth';
import { alpha, Box, Stack } from '@mui/material';

export const ReportToolSection = function ({
    style,
    tile,
    tileicons,
    userauth,
}: {
    style?: any;
    tile: TileInfo;
    tileicons?: { [key: string]: string };
    userauth: UserAuth;
}) {
    const { t } = useBundleTranslation(['app/home']);

    const defaultStyle = {};

    const toolNameAlias = tile.content_type_alias ? tile.content_type_alias : '';
    const toolName = tile.external_content_type_name ? tile.external_content_type_name : '';

    return (
        <Stack
            sx={{
                ...style,
                ...defaultStyle,
            }}
            direction={'row'}
            justifyContent={'space-between'}
            alignItems={'center'}
            className={'tile-element__report-tool-section'}
        >
            <Stack className={'tile-element__report-tool-section-icon-text'} direction={'row'} alignItems={'center'}>
                {['external report', 'other external content'].includes(tile.element_type || '') &&
                    ReportingToolIcon(tileicons, toolNameAlias || '')}
                {['external report', 'other external content'].includes(tile.element_type || '') && toolName}
                {['metric', 'internal report'].includes(tile.element_type || '') &&
                    tile.last_measurement_time_formatted}
            </Stack>

            {'1' == tile.is_expired && (
                <Box className={'tile-element__report-tool-section-expired-label'}>{t('expired')}</Box>
            )}
        </Stack>
    );
};
